module.exports = __webpack_public_path__ + "passport/img/ETCLD.9680713d.jpg";